export const selectFingerprint = (state) => state.user.fingerprint;

export const selectIsInitialized = (state) => state.user.isInitialized;
